const initialState = {
  fetchingCategories: true,
  fetchingShares: true,
  rewardsCategories: {
    categories: [],
    totalValue: 0,
    extraCategories: [],
  },
  categoryDrilldown: [],
  redirectToRoot: false,
  shareData: {
    shares: [],
    granted: null,
  },
  ltiPlans: {
    currency: null,
    years: [],
    plans: [],
    total: [],
  },
  rewardDetailsError: null,
  isLoadingLtiPlans: false,
  isLoadingDetails: true,
  personalDetailsSetting: [],
  totalAnnualBasePay: null,
  targetBonusPct: null,
  companyDescription: null,
};

export default initialState;
